import React from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import { apiCall_domain } from "../api";

const Addressmodal = (props) => {
  const handleClose = () => props.hidePopup();
  const headers = {
    Authorization: localStorage.getItem("Api_key"),
    "content-type": "application/json",
  };
  const handleDelete = (id) => {
    const Data = { id: id };
    axios.post(`${apiCall_domain}/customer/user/addresses/delete`, Data, {
      headers: headers,
    });
  };
  const setAddress = (item) => {
    props.setSelectedAddress(item);
    props.hidePopup();
  };
  return (
    <section className="AddressmodalDarklayout">
      <div className="addresses">
        <div onClick={handleClose} className="Closepage"></div>
        <main className="Addressmodal">
          <div className="Selectlocation">
            <span>انتخاب محل تحویل سفارش</span>
            <Link to="/profile/addAddress">
              <button className="btn btn--addres">افزودن آدرس</button>
            </Link>
          </div>
          <div className="addressDetail">
            {props.addresses.map((item, index) => (
              <div
                className="AddressmodalBody"
                key={index}
                onClick={() => {
                  setAddress(item);
                }}
              >
                <span>{item.title}</span>
                <span>{item.address}</span>
                <div className="AddressmodalContent">
                  <div className="Addressmodaltext">
                    <span>شماره تماس :</span>
                    <span>{item.address_phone}</span>
                  </div>
                  <div className="Addressmodalimage">
                    <Link to={`/profile/editAddress/${item.id}`}>
                      <i className="icon-pen" />
                    </Link>
                    <i
                      className="icon-delete"
                      onClick={() => {
                        handleDelete(item.id);
                      }}
                    />
                  </div>
                </div>
              </div>
            ))}
          </div>
        </main>
      </div>
    </section>
  );
};
export default Addressmodal;
